/* Component rendered on the hospitals Page to display the hospitals */
import React from "react"
import { useHistory } from "react-router-dom"
import { axiosInstance, axiosReq } from "../../api/axiosDefaults"
import styles from "../../styles/Characters.module.css"
import Col from "react-bootstrap/Col"
import Row from "react-bootstrap/Row"
import { PostDropdown } from "../../components/PostDropdown"
import { useCurrentUser } from "../../contexts/CurrentUserContext"
import { CLIENT_PROGRAM_HOSTNAME } from "../../utils/config"
import useHostName from "../../hooks/useHostName"
import toast from "react-hot-toast";

const HospitalTop = (props) => {
  const host = useHostName()
  const currentUser = useCurrentUser()
  const {
    id,
    name,
    address_line_1,
    address_line_2,
    address_line_3,
    onDeleteSuccess,
  } = props
  const history = useHistory()

  const handleEdit = () => {
    history.push(`/${localStorage.getItem("projectSlug")}/hospitals/${id}/edit`)
  }

  const handleDelete = async () => {
    try {
      if (host === CLIENT_PROGRAM_HOSTNAME) {
        await axiosReq.delete(`/masters/hospitals/${id}/`)
        toast.success(`Hospital "${name}" Deleted`);
        onDeleteSuccess?.()
      } else {
        const response = await axiosInstance.delete(
          `${localStorage.getItem("projectSlug")}/masters/hospitals/${id}/`,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
            },
            withCredentials: true,
          }
        )
        if (response?.success === false) {
          throw response.error;
        }
        toast.success(`Hospital "${name}" Deleted Successfully!`);
        onDeleteSuccess?.()
      }
    } catch (err) {
      console.log(err);
      const backendError =
        err?.response?.data?.error ||
        err?.response?.data?.detail ||
        `Hospital "${name}" Deleted Failed!`;
      toast.error(backendError);
    }
  }
  return (
    <div className={`mx-3`}>
      <Row className={`d-flex align-items-center px-3 ${styles.Top2}`}>
        <Col className="mx-0 px-0" xs={1}></Col>
        <Col xs={10} className="px-0 text-center">
          <h5 className={` ${styles.Titlelist}`}> {name}</h5>
        </Col>
        <Col xs={1} className="text-center mx-0 p-0">
          {currentUser &&
            currentUser?.groups.length > 0 &&
            (currentUser?.groups[0]?.name === "Admin" ||
              currentUser?.groups[0]?.name === "Superadmin") && (
              <PostDropdown
                handleEdit={handleEdit}
                handleDelete={handleDelete}
              />
            )}
        </Col>
      </Row>
      <Row className={` ${styles.WhiteBack}`}>
        <Col xs={12} className="px-0 text-center">
          <p className={`${styles.Hos}`}>{address_line_1}</p>
          <p className={`${styles.Hos}`}>{address_line_2}</p>
          <p className={`${styles.Hos}`}>{address_line_3}</p>
        </Col>
      </Row>
    </div>
  )
}

export default HospitalTop
